export type GetProjectTicketsRequest = {
  pjtId: string;
  dfnSetVerNum: string;
};
